import MinHeap from "../../../lib/heap/heap";
import { GraphNode } from "./graphUtils";

export default function buildMinSpanTree(
  adjacency: Map<number, GraphNode>,
  target: number
) {
  const included: boolean[] = [];
  const weights: number[] = [];
  const edges = new MinHeap<[number, number, GraphNode]>(
    (val) => val[2].weight,
    adjacency.size
  );

  const newAdjacency = new Map<number, GraphNode>();

  included[target] = true;

  const nTarget = adjacency.get(target);
  if (nTarget) {
    newAdjacency.set(target, {
      bounds: nTarget.bounds,
      weight: 1,
      adj: [],
      z: 1,
    });

    nTarget.adj.forEach((e) => {
      const eTarget = adjacency.get(e);
      if (eTarget) {
        edges.push([target, e, eTarget]);
        weights[e] = eTarget.weight;
      }
    });

    let from: number,
      to: number,
      data: GraphNode,
      numEdges = 1;
    while (numEdges <= adjacency.size && edges.size()) {
      [from, to, data] = edges.pop();
      if (!included[to]) {
        const fromExisting = newAdjacency.get(from);
        if (fromExisting) {
          fromExisting.adj.push(to);
        } else {
          console.warn("mst: from node not found");
        }
        newAdjacency.set(to, {
          weight: data.weight,
          bounds: data.bounds,
          adj: [from],
          z: 1,
        });

        included[to] = true;
        numEdges += 1;
        data.adj.forEach((e) => {
          if (!included[e] || (weights[e] && weights[e] < e)) {
            const eTarget = adjacency.get(e);
            if (eTarget) {
              edges.push([to, e, eTarget]);
              weights[to] = eTarget.weight;
            }
          }
        });
      }
    }
  }
  return newAdjacency;
}
